export default __webpack_public_path__ + "static/media/rocket_anim_0.02b676d1.png";